export default __webpack_public_path__ + "static/media/bottom_landscape.d310983b.svg";